export default function SelectField({ 
  icon: Icon, 
  value, 
  onChange, 
  options, 
  placeholder,
  className = "" 
}) {
  return (
    <div className={`selectWrapper ${className}`}>
      {Icon && <Icon size={18} className="selectIcon" />}
      <select
        className="customSelect"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {placeholder && <option value="Tous">{placeholder}</option>}
        {options.map((opt) => {
          const isObject = typeof opt === 'object';
          const val = isObject ? opt.value : opt;
          const label = isObject ? opt.label : opt;
          return (
            <option key={val} value={val}>
              {label}
            </option>
          );
        })}
      </select>
    </div>
  );
}